import { NextPage } from 'next'
import css from 'styled-jsx/css'
import Catalog from '@ui/components/ministore/Catalog'
import Footer from '@ui/components/shared/Footer'
import Header from '@ui/components/shared/Header'
import { useEffect, useRef, useState } from 'react'
import { useAgents } from '@ui/hooks'
import { logger } from '@ui/analytics'

const IndexPage: NextPage = () => {
  const [isNormalBattery, setIsNormalBattery] = useState(true)
  const refIsCheckBattery = useRef(true)
  useEffect(() => {
    setIsNormalBattery(!!refIsCheckBattery.current)
  }, [refIsCheckBattery.current])

  const isIOS = useAgents()
  useEffect(() => {
    if (isIOS == 'IOS') {
      setTimeout(() => {
        const videos = document.getElementsByTagName('video') as HTMLCollectionOf<HTMLVideoElement>
        if (videos.length) {
          const handleVideoPlayback = (videoElement: HTMLVideoElement) => {
            const playPromise = videoElement.play()
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Handle autoplay failure
                refIsCheckBattery.current = false
                setIsNormalBattery(false)
                logger.logProductEvent('low_battery')
              })
            }
          }

          Array.from(videos)?.forEach((video: HTMLVideoElement) => {
            if (video.readyState >= 2) {
              // Indicates that enough data is available to play
              handleVideoPlayback(video)
            } else {
              video.addEventListener('loadedmetadata', () => handleVideoPlayback(video))
            }
          })
        }
      }, 100)
    }

    // Attempt to play the video
  }, [isIOS])

  return (
    <div className="product-page">
      <style jsx global>
        {globalStyle}
      </style>

      <>
        <Header haveSaleBar />
        <Catalog isNormalBattery={isNormalBattery} />
        <Footer />
      </>
    </div>
  )
}

const globalStyle = css.global`
  .product-page {
    .top-description {
      margin-bottom: 61px;
    }

    @media screen and (max-width: 768px) {
      .product-images {
        margin-bottom: 24px;
      }
    }
  }
`

export default IndexPage
